<template>
  <div
    class="mapbox"
    id="mapbox"
    :style="'width:' + width + ';height:' + height"
  >
    <d-container fluid class="main-content-container px-4">
      <d-row
        no-gutters
        class="page-header py-2 pb-4 mb-3 border-bottom"
        style="height: 1000px"
      >
        <div class="main_alertbox"></div>

        <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
          <d-card class="card-small mb-4 pt-3">
            <d-card-header class="border-bottom">
              <d-col>
                <span class="text-uppercase page-subtitle">Overview</span>
                <h3 class="page-title">Realtime Indoor Map</h3>
                <span class="text-uppercase page-subtitle"
                  >Children Details Status
                </span>
                <br />
                Last Update At: {{ detailsStatus.lastUpdateTime }}<br />
                <h6 class="m-0">
                  Children Count: {{ wristband.length }}
                </h6></d-col>
            </d-card-header>
            <d-list-group flush>
              <d-list-group-item>
                <router-link to="/Mapmodel">
                  <d-button pill> Full (TEST)</d-button>
                </router-link>
              </d-list-group-item>
            </d-list-group>
          </d-card>
        </d-col>
      </d-row>

      <d-col>
        <p>Size Select</p>
        <d-select
          id="select"
          size="sm"
          value="100"
          style="max-width: 130px"
          @change="ChangeBigSmall($event)"
        >
          <option value="15">15%</option>
          <option value="50">50%</option>
          <option value="100">100%</option>
          <option value="150">150%</option>
        </d-select>
      </d-col>

      <table
        class="imgbox"
        id="imgbox"
        @mousedown="holdDown"
        @mouseup="holdUp"
        :style="'top: ' + imgtop + 'px;left: ' + imgleft + 'px;'"
        border="0"
        @mousewheel.prevent="rollImg"
        cellpadding="0"
        cellspacing="0"
        style="margin: 0 auto"
      >
        <tr>
          <td>
            <div ref="bigImage">
              <img
                id="backgroundImg"
                draggable="false"
                :style="'height: ' + imgheight + '%;'"
                alt
                @mousewheel="rollImg(this)"
                src="@/assets/images/Map.png"
              />

              <div v-for="point in wristband" :key="point.wristbandId">
                <div v-if="point.status == 'Warning'" :style="colorforchild_r">
                  <div
                    class="pointimg"
                    v-bind:style="{
                      top: point.y + 'px',
                      left: point.x + 'px',
                    }"
                    @mouseover="ShowWristbandDetails(point.wristbandId)"
                  >
                    <div class="circular--portrait">
                      <img :src="point.icon" draggable="false" alt="child" />

                      <div class="hoverbox">
                        <div class="hoverbox_imgcircular">
                          <img
                            :src="point.icon"
                            draggable="false"
                            alt="child"
                          />
                        </div>
                        <div class="hoverbox_text" name="hoverbox_name">
                          ABC
                        </div>
                        <div class="hoverbox_content" name="Location">
                          <div class="hoverbox_flex">
                            <div class="hoverbox_flex_l">
                              <i class="fas fa-street-view"></i>
                            </div>

                            <div class="hoverbox_flex_c"></div>
                            <div class="hoverbox_flex_r">
                              <div
                                class="hoverbox_flex_r"
                                name="Location_point"
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div class="hoverbox_content" name="Temperature">
                          <div class="hoverbox_flex">
                            <div class="hoverbox_flex_l">
                              <i class="fas fa-thermometer-half"></i>
                            </div>

                            <div
                              class="hoverbox_flex_c"
                              name="Temperature_point"
                            ></div>
                            <div class="hoverbox_flex_r">
                              <div class="hoverbox_point"></div>
                            </div>
                          </div>
                        </div>
                        <div class="hoverbox_content" name="Heartbeat">
                          <div class="hoverbox_flex">
                            <div class="hoverbox_flex_l">
                              <i class="fas fa-heartbeat"></i>
                            </div>

                            <div
                              class="hoverbox_flex_c"
                              name="Heartbeat_point"
                            ></div>
                            <div class="hoverbox_flex_r">
                              <div class="hoverbox_point"></div>
                            </div>
                          </div>
                        </div>

                        <!-- <p class="image__description">健康狀態.</p> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="point.status == 'Normal'" :style="colorforchild_g">
                  <div
                    class="pointimg"
                    v-bind:style="{
                      top: point.y + 'px',
                      left: point.x + 'px',
                    }"
                    @mouseover="ShowWristbandDetails(point.wristbandId)"
                  >
                    <div class="circular--portrait">
                      <img :src="point.icon" draggable="false" alt="child" />

                      <div class="hoverbox">
                        <div class="hoverbox_imgcircular">
                          <img
                            :src="point.icon"
                            draggable="false"
                            alt="child"
                          />
                        </div>
                        <div class="hoverbox_text" name="hoverbox_name">
                          ABC
                        </div>
                        <div class="hoverbox_content" name="Location">
                          <div class="hoverbox_flex">
                            <div class="hoverbox_flex_l">
                              <i class="fas fa-street-view"></i>
                            </div>

                            <div class="hoverbox_flex_c"></div>
                            <div class="hoverbox_flex_r">
                              <div
                                class="hoverbox_flex_r"
                                name="Location_point"
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div class="hoverbox_content" name="Temperature">
                          <div class="hoverbox_flex">
                            <div class="hoverbox_flex_l">
                              <i class="fas fa-thermometer-half"></i>
                            </div>

                            <div
                              class="hoverbox_flex_c"
                              name="Temperature_point"
                            ></div>
                            <div class="hoverbox_flex_r">
                              <div class="hoverbox_point"></div>
                            </div>
                          </div>
                        </div>
                        <div class="hoverbox_content" name="Heartbeat">
                          <div class="hoverbox_flex">
                            <div class="hoverbox_flex_l">
                              <i class="fas fa-heartbeat"></i>
                            </div>

                            <div
                              class="hoverbox_flex_c"
                              name="Heartbeat_point"
                            ></div>
                            <div class="hoverbox_flex_r">
                              <div class="hoverbox_point"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </d-container>
  </div>
</template>
<script scoped>
import axios from "axios";
import $ from "jquery";

export default {
  props: {
    //图片路径
    img: {
      type: String,
      default: "",
    },
    //盒子的宽
    width: {
      type: String,
      default: "100%",
    },
    //盒子的高
    height: {
      type: String,
      default: "100%",
    },
  },
  data() {
    return {
      closealert: false,
      job: {
        enable: true,
        id: null,
      },
      wristband: [],
      detailsStatus: "",
      showdetailsStatus: "",
      imgtop: 200, //图片距离左边的距离
      imgleft: -200, //图片距离上边的距离
      imgheight: 100, //图片高度百分比
      DownUp: false, //用来判断鼠标是否长按
      onclickcount: 0,
      colorforchild_g: {
        "--color": "rgb(64,255,45)",
      },
      colorforchild_r: {
        "--color": "rgb(255,0,0)",
      },
    };
  },
  mounted() {
    this.ViewMap = true;
    // console.log(this.ViewMap);
    this.getWristband();
    document.onmousemove = this.mouseMove;
    //等待图片加载
    setTimeout((e) => {
      this.getbackgroundImgWidth();
    }, 500);
    //console.log("this is " + (localStorage.getItem("loggedin") === null));
    return localStorage.getItem("loggedin") === null;
  },
  beforeDestroy() {
    document.onmousemove = null;
  },
  destroyed() {
    this.job.enable = false;
    clearTimeout(this.job.id);
  },
  methods: {
    rollImg() {
      /* 获取当前页面的缩放比
            若未设置zoom缩放比，则为默认100%，即1，原图大小
        */
      var zoom = parseInt(this.$refs.bigImage.style.zoom) || 100;
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom
            wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动
        */
      zoom += event.wheelDelta / 100;
      /* 最小范围 和 最大范围 的图片缩放尺度 */
      if (zoom >= 15 && zoom < 200) {
        this.$refs.bigImage.style.zoom = zoom + "%";
      }

      return false;
    },

    ChangeBigSmall(event) {
      //改变大小
      this.$refs.bigImage.style.zoom = event + "%";
      if (event == 50) {
        this.imgtop = 200;
        this.imgleft = 100;
      } else if (event == 100) {
        this.imgtop = 200;
        this.imgleft = 0;
      } else if (event == 150) {
        this.imgtop = 200;
        this.imgleft = -200;
      } else if (event == 15) {
        this.imgtop = 200;
        this.imgleft = 200;
      }
    },

    //鼠标按下
    holdDown() {
      this.DownUp = true;
    },
    //鼠标松开
    holdUp() {
      //console.log("you select ");
      this.DownUp = false;
    },
    //ev：鼠标对象，id：盒子的id 判断鼠标是否在盒子内
    inBoxIsoutbox(id, ev = event || window.event) {
      let map = document.getElementById(id);
      if (
        this.mousePosition(ev).x > map.offsetLeft + map.offsetWidth + 100 ||
        this.mousePosition(ev).x < map.offsetLeft ||
        this.mousePosition(ev).x < 370 ||
        this.mousePosition(ev).y > map.offsetTop + map.offsetHeight ||
        this.mousePosition(ev).y < map.offsetTop
      ) {
        return false;
      } else {
        return true;
      }
    },
    //兼容后，返回X，Y
    mousePosition(ev) {
      if (ev.pageX || ev.pageY) {
        return { x: ev.pageX, y: ev.pageY };
      }
      return {
        x: ev.clientX + document.body.scrollLeft - document.body.clientLeft,
        y: ev.clientY + document.body.scrollTop - document.body.clientTop,
      };
    },
    // 鼠标移动触发该方法
    mouseMove(ev) {
      ev = ev || window.event;
      if (this.inBoxIsoutbox("mapbox", ev)) {
        // 鼠标在盒子内
        this.runWheel(true);
      } else {
        // 鼠标在盒子外
        this.runWheel(false);
        this.holdUp();
      }
      if (this.DownUp) {
        // 鼠标长按时改变图片位置
        this.imgtop = this.imgtop + ev.movementY;
        this.imgleft = this.imgleft + ev.movementX;
      }
    },
    // 开启监听鼠标滑轮
    runWheel(isWheel) {
      //判断依据是 是否在盒子内部
      //true 就是开启
    },
    //统一处理滚轮滚动事件，中间件
    wheel(event) {
      let delta = 0;
      if (!event) event = window.event;
      if (event.wheelDelta) {
        //IE、chrome浏览器使用的是wheelDelta，并且值为“正负120”
        delta = event.wheelDelta / 120;
        if (window.opera) delta = -delta; //因为IE、chrome等向下滚动是负值，FF是正值，为了处理一致性，在此取反处理
      } else if (event.detail) {
        //FF浏览器使用的是detail,其值为“正负3”
        delta = -event.detail / 3;
      }
      if (delta) this.handle(delta);
    },
    //上下滚动时的具体处理函数
    handle(delta) {
      if (delta < 0) {
        //向下滚动
        if (this.imgheight > 0) {
          this.imgheight = this.imgheight - 1;
        }
      } else {
        //向上滚动
        if (this.imgheight < 500) {
          this.imgheight = this.imgheight + 1;
        }
      }
    },
    //获取背景图片的宽度或高度，和实际距离相除得到 系数distanceCoefficient
    getbackgroundImgWidth() {
      if (this.actualDistanceWidth !== 0) {
        let backgroundImg = document.getElementById("backgroundImg");
        this.distanceCoefficient =
          backgroundImg.width / this.actualDistanceWidth;
      } else if (this.actualDistanceHeight !== 0) {
        let backgroundImg = document.getElementById("backgroundImg");
        this.distanceCoefficient =
          backgroundImg.height / this.actualDistanceWidth;
      }
      this.$refs.bigImage.style.zoom = 15 + "%";
      this.imgtop = 200;
      this.imgleft = 10;
    },

    //------------------------------------------------------------------------------------------------------------

    getWristband() {
      var $this = this;
      this.job.id = setTimeout(() => {
        axios
          .get(
            //"https://wepark-backend.ive.appliedtech.ltd/api/staff/Wristband/random-data"
            process.env.VUE_APP_API+'api/staff/Wristband/random'
            ,{
              params: {
    random: true
  },
            }
          )
          .then((response) => {
 
            if ($this.job.enable) {
  
              var problem = 0;
              var tempdata;
              

              tempdata = response.data.result;
    //           tempdata = [{
    //   "wristbandId": "1",
    //   "icon": "https://uploads1.bundoo.com/wp-content/uploads/2015/01/What-kind-of-child-do-you-haveTHUMB-800x500.png",
    //   "gender": "M",
    //   "x": 0,
    //   "y": 0,
    //   "status": "Normal"
    // },{
    //   "wristbandId": "2",
    //   "icon": "https://uploads1.bundoo.com/wp-content/uploads/2015/01/What-kind-of-child-do-you-haveTHUMB-800x500.png",
    //   "gender": "M",
    //   "x": 200,
    //   "y": 100,
    //   "status": "Normal"
    // },{
    //   "wristbandId": "3",
    //   "icon": "https://uploads1.bundoo.com/wp-content/uploads/2015/01/What-kind-of-child-do-you-haveTHUMB-800x500.png",
    //   "gender": "M",
    //   "x": 360,
    //   "y": 130,
    //   "status": "Normal"
    // },{
    //   "wristbandId": "4",
    //   "icon": "https://uploads1.bundoo.com/wp-content/uploads/2015/01/What-kind-of-child-do-you-haveTHUMB-800x500.png",
    //   "gender": "M",
    //   "x": 500,
    //   "y": 150,
    //   "status": "Normal"
    // }]
           
              for (var startdata in tempdata) {
                tempdata[startdata].y = 652 - tempdata[startdata].y;
                
              }
              $this.wristband = tempdata;
              
              for (var point in $this.wristband) {
                if ($this.wristband[point].status != "Normal") {
                  problem++;
                  var alert =
                    "<div class='alertbox_map'> Warning, please pay attention to the map ,There has " +
                    problem +
                    " Child Problem</div>";
                  $(".alertbox_map").remove();

                  $(".main_alertbox").addClass("alertbox");
                  $(".alertbox").append(alert);
                  $(".alertbox_map").click(function () {
                    $(".main_alertbox").removeClass("alertbox");
                    $(".alertbox_map").remove();
                    this.closealert = false;
                  });
                }
                
              }

              $this.getWristband();
            }
          })
          .catch(function (error) {
            //console.log(error);
          });
      }, 2000);
    },
    async ShowWristbandDetails(id) {
      await axios
        .get(
         //`https://wepark-backend.ive.appliedtech.ltd/api/staff/Wristband/random-data/${id}`
           `https://wepark-backend-uat.ive.appliedtech.ltd/api/staff/Wristband/random-data/${id}`
        )
        .then((response) => {
          this.detailsStatus = response.data.result;
          this.showdetailsStatus =
            "Name : " +
            this.detailsStatus.name +
            "\nHeartrate : " +
            this.detailsStatus.heartrate +
            "\nTemperature : " +
            this.detailsStatus.temperature;
          var htmlnamecount = document.querySelectorAll(
            "[name='hoverbox_name']"
          );
          for (var set = 0; set < htmlnamecount.length; set++) {
            var name = document.getElementsByName("hoverbox_name")[set];
            name.innerHTML = this.detailsStatus.name;
            var loc = document.getElementsByName("Location_point")[set];
            loc.innerHTML = "A4";
            var tem = document.getElementsByName("Temperature_point")[set];
            tem.innerHTML = parseInt(this.detailsStatus.temperature);
            var heard = document.getElementsByName("Heartbeat_point")[set];
            heard.innerHTML = this.detailsStatus.heartrate;
          }
        });
    },
    set: function (message) {
      //console.log(this.onclickcount);
      if (this.onclickcount == 1) {
        this.ViewMap = true;
        this.onclickcount = 0;
      }
      if (message == "0" && this.onclickcount == 0) {
        //console.log("i am in");
        this.ViewMap = false;
        this.onclickcount = 1;
      }
    },
  },
};
</script>
<style scoped>
.mapbox {
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
}
.mapbox {
  overflow: hidden;
  position: relative;
  text-align: center;
}
.imgbox {
  position: absolute;
}
.imgbox img {
  width: auto;
  height: auto;
  cursor: pointer;
}

@keyframes up-right {
  0% {
    transform: scale(1);
    opacity: 0.25;
  }
  50% {
    transform: scale (1, 5);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.25;
  }
}

.circular--portrait {
  border: 10px solid var(--color);
  position: absolute;
  width: 100px;
  height: 100px;
  overflow: hidden;

  border-radius: 50%;
  transition: all 0.3s ease;
  transition-delay: 0s;
}

.pointimg {
  position: absolute;
}

.circular--portrait img {
  width: 100%;
  height: 100%;
}

.circular--portrait:hover {
  overflow: visible;
  border-radius: 0;
}
div.appear {
  width: 250px;
  border: #000 2px solid;
  background: #f8f8f8;
  position: relative;
  top: 5px;
  left: 15px;
  display: none;
  padding: 0 20px 20px 20px;
  z-index: 1000000;
}
div.hover {
  cursor: pointer;
  width: 5px;
}
div.hover:hover div.appear {
  display: block;
}

/*图片长hover */
.image__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.25s;
}

.image__overlay--blur {
  backdrop-filter: blur(5px);
}

.image__overlay--primary {
  background: #009578;
}

.image__overlay > * {
  transform: translateY(20px);
  transition: transform 0.25s;
}

.image__overlay:hover {
  opacity: 1;
}

.image__overlay:hover > * {
  transform: translateY(0);
}

.image__title {
  font-size: 2em;
  font-weight: bold;
}

.image__description {
  font-size: 1.25em;
  margin-top: 0.25em;
}

/* 弹出弹窗 */

.link:before {
  content: "";
  position: absolute;
  opacity: 0;
  pointer-events: none;
  top: 40%;
  transform: translate3d(-50%, 0%, 0);
  transition: all 0.3s ease;
  transition-delay: 0s;
  width: 200px;
  left: 100px;
  height: 170px;
  border-style: solid;
  border-width: 100px 100px 0 100px;
  border-color: #0077ff transparent transparent transparent;
}

.link:after {
  text-transform: none;
  content: attr(data-tooltip);
  font-size: 100px;
  position: absolute;
  color: rgb(0, 0, 0);
  background-color: #ffffff;
  height: 10em;
  padding: 30px 32px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  max-width: 1000px;
  opacity: 0;
  pointer-events: none;
  left: 130px;
  top: -150px;
  border-radius: 0;
  transform: translate3d(-50%, 0%, 0);
  transition: all 0.3s ease;
  transition-delay: 0s;

  border: solid 20px #d83a3a;
}
.link:hover {
  background-color: rgba(0, 0, 0, 0.12);
}
.link:hover:before,
.link:hover:after {
  opacity: 1;
}
.link:hover:before {
  transform: translate3d(-50%, calc(-100% - 18px), 0);
}
.link:hover:after {
  transform: translate3d(-50%, calc(-100% - 16px), 0);
}

/* CSS ICON ALERT GENERAL */
.screenAlert-icon {
  border-radius: 50%;
  border: 4px solid gray;
  box-sizing: content-box;
  height: 200px;
  margin: 20px auto;
  padding: 0;
  position: relative;
  width: 200px;
}
.screenAlert-icon + .screenAlert-icon {
  margin-top: 50px;
}
/* CSS WARNING */
.screenAlert-icon.screenAlert-warning {
  border-color: #ffd000;
}
.screenAlert-icon.screenAlert-warning:before {
  -webkit-animation: pulseWarning 2s linear infinite;
  animation: pulseWarning 2s linear infinite;
  background-color: transparent !important;
  border-radius: 50%;
  content: "";
  display: inline-block;
  height: 100%;
  opacity: 0;
  position: absolute;
  width: 100%;
}
.screenAlert-icon.screenAlert-warning:after {
  background-color: transparent !important;
  border-radius: 50%;
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.screenAlert-icon.screenAlert-warning .screenAlert-body {
  background-color: #ffd000;
  border-radius: 2px;
  height: 130px;
  left: 45%;
  margin-left: -6px;
  position: absolute;
  top: 10px;
  width: 30px;
  z-index: 2;
}
.screenAlert-icon.screenAlert-warning .screenAlert-dot {
  background-color: #f8bb86;
  border-radius: 50%;
  bottom: 10px;
  height: 30px;
  left: 50%;
  margin-left: -16px;
  position: absolute;
  width: 30px;
  z-index: 2;
}
.scaleWarning {
  -webkit-animation: scaleWarning 0.75s infinite alternate;
  animation: scaleWarning 0.75s infinite alternate;
}
.pulseWarningIns {
  -webkit-animation: pulseWarningIns 0.75s infinite alternate;
  animation: pulseWarningIns 0.75s infinite alternate;
}
/* ANIMATE WARNING */
@-webkit-keyframes scaleWarning {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  30% {
    -webkit-transform: scale(1.02);
    transform: scale(1.02);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes scaleWarning {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  30% {
    -webkit-transform: scale(1.02);
    transform: scale(1.52) translateY(-50px);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@-webkit-keyframes pulseWarning {
  0% {
    background-color: #fff;
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0.5;
  }
  30% {
    background-color: #fff;
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0.5;
  }
  100% {
    background-color: #f8bb86;
    -webkit-transform: scale(2);
    transform: scale(2);
    opacity: 0;
  }
}
@keyframes pulseWarning {
  0% {
    background-color: #fff;
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0.5;
  }
  30% {
    background-color: #fff;
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0.5;
  }
  100% {
    background-color: #f8bb86;
    -webkit-transform: scale(2);
    transform: scale(2);
    opacity: 0;
  }
}
@-webkit-keyframes pulseWarningIns {
  0% {
    background-color: #ff0000;
  }
  100% {
    background-color: #ff0000;
  }
}
@keyframes pulseWarningIns {
  0% {
    background-color: #ff0000;
  }
  100% {
    background-color: #f8bb86;
  }
}

.alertbox {
  background-color: #f44336;
  color: white;
  position: absolute;
  z-index: 1;
  padding: 10px 10px;
  border-radius: 5px;
  right: 40%;
  width: auto;
}

@media screen and (max-width: 1500px) {
  .alertbox {
    width: 300px;
    right: 30%;
  }
}
.alertboxconect {
  background-color: blue;
  color: white;
}
.closebtn {
  margin-left: 15px;
  color: rgb(0, 0, 0);
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.closebtn:hover {
  color: black;
}

.hoverbox {
  /* content: attr(data-tooltip); */
  position: absolute;
  width: 820px;
  height: 1200px;

  border: 30px solid var(--color);
  box-sizing: border-box;
  border-radius: 50px;
  padding-top: 60px;
  padding-bottom: 60px;
  padding-right: 60px;
  padding-left: 60px;
  background-color: #fff;
  opacity: 1;
  pointer-events: none;
  transform: translate3d(-50%, 0%, 0);
  transition: all 0.3s ease;
  transition-delay: 0s;
  left: 100px;
  top: -1400px;
}

.hoverbox_flex {
  display: flex;
  width: 100%;
}

.hoverbox_flex_l {
  width: 30%;
  flex: 1 1 auto;
}
.hoverbox_flex_c {
  width: 30%;
  flex: 1 1 auto;
}
.hoverbox_flex_r {
  width: 30%;
  flex: 1 1 auto;
}

.hoverbox_point {
  position: relative;
  width: 60px;
  height: 60px;
  top: 10px;
  left: 25%;
  background: var(--color);
  border: 10px solid #000000;
  border-radius: 50%;
}
.hoverbox_content {
  display: flex;
  position: relative;
  width: 600px;
  height: 100px;
  top: 100px;
  margin: 60px 0;
  border: 10px solid #000;
  box-sizing: border-box;
  border-radius: 50px;
  font: 4.2em "Fira Sans", sans-serif;
  font-weight: bold;
  color: #000;
}

.hoverbox_imgcircular {
  border: 15px solid var(--color);
  position: relative;
  width: 300px;
  height: 300px;
  overflow: hidden;
  left: 180px;
  border-radius: 50%;
}

.hoverbox_imgcircular img {
  width: 100%;
  height: auto;
}

.hoverbox_text {
  position: relative;
  margin: 60px 0;
  top: 50px;
  font: 4.2em "Fira Sans", sans-serif;
  font-weight: bold;
  line-height: 35px;

  color: #000000;
}

.hoverbox:hover {
  transform: translate3d(-50%, calc(-100% - 18px), 0);
  opacity: 1;
}

.hoverbox_content:hover {
  transform: translate3d(-50%, calc(-100% - 18px), 0);
  opacity: 1;
}
</style>